// src/context/AuthContext.js
// بيحفظ حالة تسجيل الدخول ويوفرها لكل المشروع

import React, { createContext, useContext, useEffect, useState } from 'react';
import { listenToAuthChanges, loginUser, logoutUser } from '../firebase/auth';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = listenToAuthChanges((user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const login = (email, password) => loginUser(email, password);
  const logout = () => logoutUser();

  const value = { currentUser, login, logout, loading };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
